import styled, { css, keyframes } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const SpinnerContainer = styled.div`
  ${FlexCenter}
  path.fill {
    fill: var(--text-tertiary);
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const AnimatedArc = styled.div`
  width: 48px;
  height: 48px;
  border-radius: var(--border-radius-full);
  border: 2px solid var(--background-muted);
  border-top: 2px solid var(--text-primary);
  position: absolute;
  animation: ${rotate} 1s linear infinite;
  &.dark-border {
    border: 2px solid var(--background-tertiary);
    border-top: 2px solid var(--text-primary);
  }
`;

const BlankNavbar = styled.div`
  height: 100%;
  width: 100%;
  max-width: 210px;
  border-right: 0.5px solid var(--border-primary);
  background-color: var(--background-navbar);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const LoadingContent = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
  flex-direction: column;
  width: 100%;
`;

const WorkSpaceLoadingWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
  width: 100%;
  background-color: var(--background-secondary);
  p {
    margin: var(--space-0);
    ${Typography.body_lg_medium};
    color: var(--text-secondary);
  }
  ${mobile_xl(css`
    max-width: unset;
    height: 100%;
  `)}
`;
export { AnimatedArc, SpinnerContainer, rotate, WorkSpaceLoadingWrapper, BlankNavbar, LoadingContent };
